import { render, staticRenderFns } from "./LotRecall.vue?vue&type=template&id=68638d9c&scoped=true"
import script from "./LotRecall.vue?vue&type=script&lang=js"
export * from "./LotRecall.vue?vue&type=script&lang=js"
import style0 from "./LotRecall.vue?vue&type=style&index=0&id=68638d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68638d9c",
  null
  
)

export default component.exports